import { ReactNode} from 'react';
import styled from 'styled-components';
import { IcRadioCheck, ICRadioNone } from '../assets';
import { Text } from '../../Text';

interface RadioItemProps {
  value?: boolean,
  children: ReactNode,
  onClick?: () => void,
  className?: string;
  style?: React.CSSProperties
  
}

const RadioItem = ({value = false, children, onClick, className, style}: RadioItemProps) => {

  return (
    <Container type='button' style={style} className={className} onClick={onClick}>
      {value ? <img src={IcRadioCheck}/> : <img src={ICRadioNone}/>}
      <Text content_2 medium>
        {children}
      </Text>
    </Container>
  );
};

export default RadioItem;

const Container = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;

  .custom-text {
    white-space: nowrap;
  }
`;